import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsconditionpolicyService {
  private baseRoute: string;
  private baseTarget: string;
  private headers: HttpHeaders;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.accountAPIRoot;
    this.baseTarget = 'TermsCondition';
    this.headers = new HttpHeaders();
  }

  getTerms<T>(): Observable<T> {
    return this.httpClient.get<T>(`${environment.accountAPIRoot}/termscondition/gettcps`);
  }

}
